import type { Account } from "@/types";
import { computed } from "vue";
import { useRoute } from "vue-router";

export function useCompanyFinder(accountData: Account) {
  const route = useRoute();

  const companyIdQueryString = computed(() => {
    return parseInt(route.query.company_id as string);
  });

  const selectedCompany = computed(() => {
    if (
      accountData &&
      accountData.companies &&
      accountData.companies[companyIndex.value]
    ) {
      return accountData.companies[companyIndex.value];
    }
    throw new Error("Company not found");
  });

  const companyIndex = computed(() => {
    if (companyIdQueryString.value) {
      return accountData.companies.findIndex(
        (company) => company.id === companyIdQueryString.value
      );
    } else {
      return findCompanyIndexWithoutId.value;
    }
  });

  const selectedCompanyOrFirst = computed(() => {
    if (
      accountData &&
      accountData.companies &&
      accountData.companies[companyIndexOrFirst.value]
    ) {
      return accountData.companies[companyIndexOrFirst.value];
    }
    return null;
  });

  const companyIndexOrFirst = computed(() => {
    if (companyIdQueryString.value) {
      return accountData.companies.findIndex(
        (company) => company.id === companyIdQueryString.value
      );
    } else {
      return 0;
    }
  });

  const findCompanyIndexWithoutId = computed(() => {
    return accountData.companies.findIndex(
      (company) => company.id === undefined || company.id === null
    );
  });

  return {
    companyIndex,
    companyIndexOrFirst,
    selectedCompany,
    selectedCompanyOrFirst,
  };
}
